import React from 'react';
import moment from 'moment';
import Chip from '@material-ui/core/Chip';
import {useGlobalState} from '../../../state';
import { version } from '../../../common/enums';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit,onPaymentEdit,amountObj}) => {
    const [{user}] = useGlobalState();
    const isPro = user.versionID === version.pro;

    // Same calculation as the desktop 'Remaining Balance' column
    function calculateRemainingBalance(rowData) {
        let paidAmount = 0
        if (rowData.otherIncomePayments) {
            rowData.otherIncomePayments.forEach(ele => {
                paidAmount += ele.paymentAmount
            })
        }
        let remaningBalance = (rowData.amount - paidAmount)
        if (rowData.paymentStatus === 1 && remaningBalance < 1) {
            remaningBalance = 0
        }
        return (remaningBalance).toLocaleString(user.locales,amountObj)
    }

    // Same conditions as the desktop 'Payment Status' column (0 = Not Paid, 1 = Partially Paid, 2 = Paid)
    function getPaymentStatus(rowData) {
        let remaningBalance = rowData.amount - rowData.remainingBalance
        if (rowData.paymentStatus === 1 && remaningBalance >= 1) {
            return 1
        } else if (rowData.paymentStatus === 2 || (rowData.paymentStatus === 1 && remaningBalance < 1)) {
            return 2
        }
        return 0
    }

    const paymentStatus = getPaymentStatus(data);

    const rows = [
        { label: 'Farm Name', value: data.farmName },
        { label: 'Income Type', value: data.incomeTypeName },
        (user.versionID === version.proPlus) && { label: 'Customer', value: data.customerName },
        { label: 'Amount (in Rs.)', value: data.amount },
        !isPro && { label: 'Remaining', value: calculateRemainingBalance(data) },
        !isPro && { label: 'Payment', inHeader: true, hideLabel: true, value: (
            <Chip
                label={paymentStatus === 0 ? "Not Paid" : paymentStatus === 1 ? "Partially Paid" : "Paid"}
                style={{
                    backgroundColor:
                        paymentStatus === 0 ? "#f44336" :
                        paymentStatus === 1 ? "#ffeb3b" : "#4caf50",
                    color: paymentStatus === 1 ? "#000" : "#fff",
                }}
                size="small"
                className="pp-pill"
            />
        )},
    ].filter(Boolean);

    const menuItems = [
        !isPro && onPaymentEdit && { label: 'Payment Details', onClick: onPaymentEdit },
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ].filter(Boolean);

    return (
        <PPMobileCardView
            title={moment(data.date).format("DD-MM-YYYY")}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
